import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";
import PikiLogo from "@/components/PikiLogo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("piki_admin_token", r.data.token);
      localStorage.setItem("piki_admin_email", r.data.email);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-md piki-card p-8">
        <div className="flex items-center justify-center mb-2">
          <PikiLogo className="h-20 w-auto" />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold text-white text-center">Admin Sign-in</h1>
        <p className="text-sm text-[#A3A3A3] mt-1 text-center">Manage fleet, rates & bookings.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs text-[#A3A3A3] mb-1.5 block">Email</label>
            <input type="email" className="piki-input text-sm" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" />
          </div>
          <div>
            <label className="text-xs text-[#A3A3A3] mb-1.5 block">Password</label>
            <input type="password" className="piki-input text-sm" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" />
          </div>
          <button type="submit" disabled={busy} className="piki-gold-btn w-full flex items-center justify-center gap-2" data-testid="admin-login-submit-btn">
            <Lock className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
